import { useEffect } from "react";

const FintezaTracker = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;

    script.innerHTML = `(function(a,e,f,g,b,c,d){
      a[b]||(a.FintezaCoreObject=b,a[b]=a[b]||function(){
      (a[b].q=a[b].q||[]).push(arguments)},a[b].l=1*new Date,
      c=e.createElement(f),d=e.getElementsByTagName(f)[0],
      c.async=!0,c.defer=!0,c.src=g,d&&d.parentNode&&d.parentNode.insertBefore(c,d))
    })(window,document,"script","https://content.mql5.com/core.js","fz");
    fz("register","website", "xxlclzeaeyoarxflujnwkdxzqgbnfvldii");`;

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
};

export default FintezaTracker;